__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dfx-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884), __webpack_require__.e(127)]).then(() => (() => (__webpack_require__(1479))))));
			register("@liquid-os/ui", "0.1.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(127), __webpack_require__.e(539), __webpack_require__.e(223), __webpack_require__.e(943), __webpack_require__.e(457)]).then(() => (() => (__webpack_require__(7237))))));
			register("@mui/icons-material", "0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884), __webpack_require__.e(127), __webpack_require__.e(539)]).then(() => (() => (__webpack_require__(3226))))));
			register("@mui/material", "0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(127), __webpack_require__.e(539)]).then(() => (() => (__webpack_require__(8536))))));
			register("@tanstack/react-query", "5.96.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(8980))))));
			register("ag-grid-community", "35.2.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(346))))));
			register("ag-grid-react", "35.2.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(943)]).then(() => (() => (__webpack_require__(6875))))));
			register("dayjs", "1.11.20", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(4353))))));
			register("react-dom", "19.2.4", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(961))))));
			register("react-hook-form", "7.72.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(9785))))));
			register("react-router-dom", "7.14.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(2610))))));
			register("react", "19.2.4", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))));
			register("zustand", "5.0.12", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(5618))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};